import { render } from "./EditFile.vue?vue&type=template&id=1046500c"
import script from "./EditFile.vue?vue&type=script&lang=js"
export * from "./EditFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__